<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_231_44529)">
<path d="M18.3332 9.99999C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333M18.3332 9.99999C18.3332 5.39762 14.6022 1.66666 9.99984 1.66666M18.3332 9.99999H1.6665M9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 9.99999M9.99984 18.3333C7.86003 16.0865 6.6665 13.1027 6.6665 9.99999C6.6665 6.89727 7.86003 3.91345 9.99984 1.66666M9.99984 18.3333C12.1396 16.0865 13.3332 13.1027 13.3332 9.99999C13.3332 6.89727 12.1396 3.91345 9.99984 1.66666M1.6665 9.99999C1.6665 5.39762 5.39746 1.66666 9.99984 1.66666" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_231_44529">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
</template>